"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiShieldCheck, PiGlobe, PiChatCenteredText } from "react-icons/pi";

export default function CorporateFeatures({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const features = content.features || [
    { title: "Security First", description: "Bank-grade encryption and strict compliance controls.", icon: "security" },
    { title: "Global Scale", description: "Infrastructure distributed across 20+ regions worldwide.", icon: "globe" },
    { title: "24/7 Support", description: "Dedicated customer success managers for your team.", icon: "support" }
  ];

  const iconMap: Record<string, any> = {
    security: <PiShieldCheck className="w-6 h-6 text-blue-600" />,
    globe: <PiGlobe className="w-6 h-6 text-blue-600" />,
    support: <PiChatCenteredText className="w-6 h-6 text-blue-600" />,
  };

  return (
    <section
      className={`py-24 px-6 bg-white transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight">
            <EditableText
              value={content.title || "Enterprise Solutions"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feat: any, idx: number) => (
            <div key={idx} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-4 shadow-xs">
              <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
                {iconMap[feat.icon] || <PiShieldCheck className="w-6 h-6 text-blue-600" />}
              </div>
              <h3 className="text-xl font-bold text-slate-900">{feat.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
